//library
import React, { Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
// import "@styles/react/libs/tables/react-dataTable-component.scss";
import { useState } from "react";
import { FaChevronDown, FaEdit, FaEye, FaTrash, FaCopy } from 'react-icons/fa'
import CustomPagination from "../Pagination";
import { IoMdArrowDropdown } from "react-icons/io";
import Loader from "../Loader";
import NoDataFound from "../NoDataFound";



const customStyles = {
    table: {
        style: {
            backgroundColor: "#fff",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
            // overflow: "hidden",
        },
    },
    headCells: {
        style: {
            // backgroundColor: "#f7fbff",
            // color: "#8c8c8c",
            textTransform: "uppercase",
            fontSize: "12px",
            // minHeight: "4rem",  // Set head height to 4rem (64px)
            padding: "12px",
            // display: "flex",
            // alignItems: "center",
        },
    },
    rows: {
        style: {
            borderBottom: "1px solid #e9ecef",
            // transition: "background-color 0.3s ease, transform 0.2s ease",
            '&:hover': {
                backgroundColor: "#F9FBFD",
            },
        },
    },
    cells: {
        style: {
            padding: "2px 10px",
            fontSize: "14px",
            color: "#2E384D",
            fontWeight: "500",
        },
    },
};

const Index = (props) => {

    const { columns, data, FaEditData, deleteData, onSort, loading, clearSelectedRows, totalRows, handlePagination, totalRecords, limit, setPage, setLimit, viewData, currentPage, setKYCdata, setModalKyc, noAction, setModal, modal, FaCopyURL, toolTipMsg, multiSelectRow } = props;
    // handleOnClick,
    const [newColumn, setNewColumn] = useState(columns);

    useEffect(() => {
        if (!noAction && !columns.find((column) => column?.name === "Action")) {
            setNewColumn([
                // {
                //     name: "Action",
                //     allowOverflow: true,
                //     sortable: false,
                //     cell: (row) => {
                //         return (
                //             <div className="d-flex">
                //                 {viewData && <FaEye className="me-1 cursor-pointer" id={`ss${viewData?.id}`} onClick={() => { viewData(row); setModal(!modal) }} size={17} />}
                //                 {FaEditData && <FaEdit className="me-1 cursor-pointer" size={17} onClick={() => FaEditData(row)} />}
                //                 {/* {FaCopyURL &&
                //                     <>
                //                         <FaCopy className="me-1 cursor-pointer" size={20} onClick={() => FaCopyURL(`${digitalOceanURL}${row?.url}`)} id="FaCopyText" />
                //                         <UncontrolledTooltip placement="top" target={"FaCopyText"}>
                //                             {toolTipMsg}
                //                         </UncontrolledTooltip>
                //                     </>
                //                 } */}
                //                 {deleteData && < FaTrash onClick={() => { deleteData(row?.id); }} className="text-danger cursor-pointer" size={17} />}
                //             </div>

                //         );
                //     },
                // }, 
                ...columns,
            ])
        }
    }, [columns])


    return (
        <Fragment>
            <div >
                <DataTable
                    // noHeader
                    // className="react-dataTable"
                    columns={newColumn}
                    // sortIcon={<IoMdArrowDropdown />}
                    data={data}
                    // customStyles={customStyles}
                    // onSort={onSort}
                    sorting
                    selectableRows={multiSelectRow ? true : false}
                    // selectableRows={true}
                    clearSelectedRows={clearSelectedRows}
                    onSelectedRowsChange={multiSelectRow}
                    progressPending={loading}
                    progressComponent={<div className="flex justify-center items-center h-screen w-full">
                        <Loader />
                    </div>}
                    noDataComponent={<div className="flex justify-center items-center h-screen w-full"><NoDataFound /> </div>}
                    // actions={actionsMemo}
                    // defaultSortFieldId={1}
                    // fixedHeader={true}
                    // fixedHeaderScrollHeight='300px'
                    // onRowClicked={handleRowClick}
                    // expandableRows
                    // expandableRowsComponent={({ data }) => <div style={{ padding: "10px" }}>More details about {data.name}</div>}
                    pagination
                    paginationPerPage={limit}
                    paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
                    paginationServer
                    paginationTotalRows={totalRecords}
                    // progressPending={loading}
                    onChangePage={(page) => setPage(page)}
                    onChangeRowsPerPage={(newPerPage, page) => {
                        setLimit(newPerPage);
                        setPage(page);
                    }}
                    // highlightOnHover
                    responsive
                    // striped
                    customStyles={customStyles}
                // selectableRowsComponent={Checkbox}
                // sortIcon={sortIcon}
                // onRowClicked={handleOnClick}
                />
            </div>
            {/* <CustomPagination
                currentPage={currentPage}
                handlePagination={handlePagination}
                totalRecords={totalRecords}
                limit={limit}
            /> */}
        </Fragment>
    );
};

export default Index;
